import styled from 'styled-components'

const MyDiv = styled.div`
.parent_grid{
  display: grid;
  grid-template-columns: 250px 1fr;
  transition: 0.5s;
  background: #f0f5f1;
  @media(max-width:767px){
    display: block;
}
    
}

.parent_grid_toggle{
  display: grid;
  background-color: #f0f5f1;
  grid-template-columns: 100px 1fr;
  transition: 0.5s;
}
  
.children_grid{
  padding: 16px 0px 0px 0px;
}
.children_grid_toggle{
  padding: 16px 0px 0px 0px;
}
.header-action{
  background: transparent!important;
  color: #000!important;
}
.active-header-action{
  background: #fff!important;
  color: #006838!important;
  box-shadow: 0px 2px 3px 0px #00000040;
  border-radius: 6px;
}
.inner-children{
  background: #fff;
  padding: 16px;
}
  
`
export default MyDiv
